import React from 'react'

/**
 * Orbital logo mark SVG — a sphere with two orbit rings.
 * Sizing controlled via width/height props (default 48).
 */
export function OrbitalMark({ width = 48, height = 48, className = '' }) {
    return (
        <svg
            className={`orbital-mark ${className}`}
            width={width}
            height={height}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            {/* outer ring */}
            <ellipse
                cx="50" cy="50" rx="46" ry="46"
                stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.4"
            />
            {/* diagonal orbit 1 */}
            <ellipse
                cx="50" cy="50" rx="46" ry="18"
                stroke="currentColor" strokeWidth="1"
                strokeOpacity="0.6"
                transform="rotate(-30 50 50)"
            />
            {/* diagonal orbit 2 */}
            <ellipse
                cx="50" cy="50" rx="46" ry="18"
                stroke="currentColor" strokeWidth="1"
                strokeOpacity="0.4"
                transform="rotate(30 50 50)"
            />
            {/* core sphere */}
            <circle cx="50" cy="50" r="10" fill="currentColor" />
            {/* orbital dot */}
            <circle cx="50" cy="4" r="3" fill="var(--accent-1, #ff5b3b)" />
        </svg>
    )
}
